import { Card, Box, Text, Heading, Avatar, TrackScrolledIntoView } from '@homebotapp/hb-react-component-catalog'
import { useIntl, defineMessages } from 'react-intl'
import { useSelector } from 'react-redux'
import {
  selectCompanyLogo,
  selectCustomerPhotoUri,
  selectCompanyName,
  selectCustomModules
} from '../../../../store/selectors/customerProfile'
import { LeavingHomebotCtaButton } from '../../../shared/LeavingHomebotCta/LeavingHomebotCtaButton'
import { HOME_SEARCH_CUSTOM_MODULE } from '../../../../constants/tracking/trackingEventLocations/homeSearchTrackingEventLocation'

const MSG = defineMessages({
  learnMore: {
    id: 'SearchCustomModule.learnMore',
    defaultMessage: 'Learn more'
  },
  corporationRecommends: {
    id: 'SearchCustomModule.corporationRecommends',
    defaultMessage: '{corporationName} recommends you check out their offering.'
  },
  byContinuing: {
    id: 'SearchCustomModule.byContinuing',
    defaultMessage: "By continuing, you'll go to their site in a new tab."
  }
})

export const SearchCustomModule = () => {
  const intl = useIntl()
  const corporationName = useSelector(selectCompanyName)

  const companyLogo = useSelector(selectCompanyLogo)
  const customerPhoto = useSelector(selectCustomerPhotoUri)

  const customModules = useSelector(selectCustomModules)
  const searchCustomModule = customModules?.find((module: any) => module.moduleType === 'search')
  if (!searchCustomModule) return null

  const renderModalBody = () => {
    return (
      <>
        <Text mb={4}>
          {intl.formatMessage(MSG.corporationRecommends, {
            corporationName: corporationName
          })}
        </Text>
        <Text mb={6}>{intl.formatMessage(MSG.byContinuing)}</Text>
      </>
    )
  }

  return (
    <TrackScrolledIntoView
      tracking={{
        guid: 'wgwFSANy0TO4Q3aoEWFgre',
        ui_context: HOME_SEARCH_CUSTOM_MODULE,
        descriptor: 'Search Custom Module'
      }}
    >
      <Card
        borderTopWidth={25}
        borderTopColor={'brand.600'}
        borderRadius={16}
        alignItems={'center'}
        justifyContent={'space-between'}
        px={5}
        minHeight={'338px'}
        data-qa='CustomModuleCard'
      >
        <Avatar height={55} width={55} mt={-3} mb={7} src={companyLogo ?? customerPhoto} />
        <Heading as='h3' size='sm' variant='eyebrow'>
          {searchCustomModule.title}
        </Heading>
        <Text mb={3} size={'xs'} fontWeight={'light'} align={'center'}>
          {searchCustomModule.description}
        </Text>
        <Box mb={5}>
          <LeavingHomebotCtaButton
            fullWidth
            ctaButtonSize='md'
            ctaButtonVariant='ghost'
            ctaButtonColorScheme='primary'
            ctaLinkUrl={searchCustomModule.uri}
            renderModalBody={renderModalBody}
            tracking={{
              guid: 'ogrpRetg7Q32nNStre4yZYo',
              ui_context: HOME_SEARCH_CUSTOM_MODULE,
              descriptor: 'Cta button clicked'
            }}
          >
            {intl.formatMessage(MSG.learnMore)}
          </LeavingHomebotCtaButton>
        </Box>
      </Card>
    </TrackScrolledIntoView>
  )
}
